import { BrandButton } from "../BrandButton";
import { Reveal } from "../anim";

const VARIANTS = {
  default: {
    headline: "Bring regulated assets onchain without fragmenting",
    accent: "control",
    suffix: ".",
    primary: { label: "Talk to an expert", href: "/contact" },
    secondary: { label: "Explore the Ledger", href: "/network/ledger" },
  },
  docs: {
    headline: "Read the technical",
    accent: "documentation",
    suffix: ".",
    primary: { label: "Open docs", href: "https://docs.t-rex.network/" },
    secondary: { label: "Talk to us", href: "/contact" },
  },
  contact: {
    headline: "Ready to bring regulated assets",
    accent: "onchain",
    suffix: "?",
    primary: { label: "Talk to us", href: "/contact" },
    secondary: { label: "Read the docs", href: "https://docs.t-rex.network/" },
  },
  builders: {
    headline: "Build on the",
    accent: "compliance",
    suffix: " ledger.",
    primary: { label: "Apply for a grant", href: "/contact?inquiry=builder" },
    secondary: { label: "Read the docs", href: "https://docs.t-rex.network/" },
  },
  media: {
    headline: "Press &",
    accent: "media",
    suffix: " inquiries.",
    primary: { label: "Media inquiries", href: "/contact?inquiry=media" },
  },
  token: {
    headline: "Register your interest in",
    accent: "$TREX",
    suffix: ".",
    primary: { label: "Register interest", href: "/contact?inquiry=investor" },
    secondary: { label: "Read the whitepaper", href: "https://docs.t-rex.network/" },
  },
};

/**
 * ClosingCTA — tone-aware (day | night). On Home it renders as `day` to close
 * the page on a bone surface that contrasts with the dark footer.
 */
export function ClosingCTA({ variant = "default", tone = "night" }) {
  const v = VARIANTS[variant] || VARIANTS.default;
  const isDay = tone === "day";
  const surface = isDay ? "surface-day" : "surface-night with-bloom";
  const headlineColor = isDay ? "text-aubergine" : "text-bone";

  return (
    <section
      className={`${surface} py-32 lg:py-40`}
      data-testid={`closing-cta-${variant}`}
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <Reveal className="mx-auto max-w-3xl text-center">
          <h2 className={`trex-h2 leading-[1.1] ${headlineColor}`}>
            {v.headline} <em className="accent-italic">{v.accent}</em>{v.suffix}
          </h2>
          <div className="mt-10 flex flex-col sm:flex-row justify-center gap-4">
            {v.primary && (
              <BrandButton
                variant="champagne"
                tone={tone}
                to={/^https?:/.test(v.primary.href) ? undefined : v.primary.href}
                href={/^https?:/.test(v.primary.href) ? v.primary.href : undefined}
                external={/^https?:/.test(v.primary.href)}
                data-testid="closing-cta-primary"
              >
                {v.primary.label}
              </BrandButton>
            )}
            {v.secondary && (
              <BrandButton
                variant="ghost"
                tone={tone}
                to={/^https?:/.test(v.secondary.href) ? undefined : v.secondary.href}
                href={/^https?:/.test(v.secondary.href) ? v.secondary.href : undefined}
                external={/^https?:/.test(v.secondary.href)}
                data-testid="closing-cta-secondary"
              >
                {v.secondary.label}
              </BrandButton>
            )}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
